import { client } from '../client';
import { urls } from '../endpoints';
import {
  ApiResponse,
  GridResponse,
  Sport,
  SportsCreationType,
  SportSearchParams,
} from '../../types/types';

export const createSportRequest = async (sportData: SportsCreationType) => {
  try {
    const response = await client.post<ApiResponse<number>>(
      urls.createSport,
      sportData,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error creating sport:', error);
    throw error;
  }
};

export const updateSportRequest = async (
  sportId: number,
  sportData: SportsCreationType,
) => {
  try {
    const response = await client.put<ApiResponse<number>>(
      urls.updateSport(sportId),
      sportData,
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error updating sport:', error);
    throw error;
  }
};

export const getAllSportsRequest = async (params?: SportSearchParams) => {
  try {
    const response = await client.get<ApiResponse<GridResponse<Sport[]>>>(
      urls.getAllSports(params),
    );

    if (response.status !== 200 || response.data.isFailure) {
      throw new Error(response.data.error || 'Failed to fetch sports');
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching sports:', error);
    throw error;
  }
};

export const deactivateSportRequest = async (sportId: number) => {
  try {
    const response = await client.post(urls.deactivateSport(sportId));

    if (response.status !== 200 || response.data.isFailure) {
      throw new Error(response.data.error || 'Failed to deactivate sport');
    }

    return response.data.value;
  } catch (error) {
    console.error('Error deactivating sport:', error);
    throw error;
  }
};

export const deleteSportRequest = async (sportId: number) => {
  try {
    const response = await client.delete<ApiResponse<number>>(
      urls.deleteSport(sportId),
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting sport:', error);
    throw error;
  }
};
